import { notifyError, notifySuccess } from "../../components/Utils";
import * as actionTypes from "./actions";

const initialState = {
  loading: false,
  isNGUMActive: false,
  data: {},
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_NGUM_STATUS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.LOAD_NGUM_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        isNGUMActive: action.result.status_id === 1,
        data: action.result,
      };
    case actionTypes.LOAD_NGUM_STATUS_FAILURE:
      notifyError({
        summary: `nGUM Status`,
        detail: `nGUM Status konnte nicht erfolgreich gelesen werden!`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    case actionTypes.TOGGLE_NGUM:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.TOGGLE_NGUM_SUCCESS: {
      const isNGUMActive = action.result.status_id === 1;
      notifySuccess({
        summary: `nGUM ${isNGUMActive ? "ein" : "aus"}schalten`,
        detail: `nGUM wurde erfolgreich ${isNGUMActive ? "ein" : "aus"}geschaltet!`,
      });
      return {
        ...state,
        loading: false,
        isNGUMActive,
        data: action.result,
      };
    }
    case actionTypes.TOGGLE_NGUM_FAILURE:
      notifyError({
        summary: `nGUM ${action.isActive ? "ein" : "aus"}schalten`,
        detail: `nGUM konnte nicht erfolgreich ${action.isActive ? "ein" : "aus"}geschaltet werden!`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    default:
      return state;
  }
};
